export default "__VITE_ASSET__BEAg0SV8__"